import Delegator from './utils/delegator.js';
import Looper from './utils/looper.js';

const ON_TICK = {onTick: true};
const ON_WRITE = {onWrite: true};

function Mainloop() {
	this._lastTime = -1;
	this.looper = new Looper(time => this.tick(time));
}

Delegator(Mainloop.prototype, {
	onTick: true,
	onWrite: true,
});

Mainloop.prototype.addDelegate = function (...args) {
	Delegator.prototype.addDelegate.apply(this, args);
	this.looper.start();
};

Mainloop.prototype.removeDelegate = function (...args) {
	Delegator.prototype.removeDelegate.apply(this, args);
	if ((!this._delegates.onTick || !this._delegates.onTick.length) &&
			(!this._delegates.onWrite || !this._delegates.onWrite.length)) {
		this.looper.stop();
		this._lastTime = -1;
	}
};

Mainloop.prototype.tick = function (timestamp) {
	if (this._lastTime < 0) {
		this._lastTime = timestamp;
	}

	const delta = timestamp - this._lastTime;
	this._lastTime = timestamp;
	const fps = Math.round(1000 / delta);
	const tickInfo = {timestamp, delta, fps};
	this.notifyDelegates(ON_TICK, tickInfo);
	this.notifyDelegates(ON_WRITE, tickInfo);
};

export default new Mainloop();



// WEBPACK FOOTER //
// ./lib/pagehandler/mainloop.js